<template>
    <v-tabs
        v-model="tab"
        class="round-card"
        height="34"
        background-color="background-1"
        slider-color="primary">
        <v-tab key="Campi" ripple class="secondary-tab">
            Campi
        </v-tab>
        <v-tab key="Azioni" ripple class="secondary-tab">
            Azioni
        </v-tab>
        <v-tab key="Template" ripple class="secondary-tab">
            Template
        </v-tab>
        <v-tab key="Altro" ripple class="secondary-tab">
            Altro
        </v-tab>

        <v-tab-item class="background-1 pt-3 pb-1" key="Campi">
            <v-row class="ma-0">
                <v-col class="pa-0 pt-2" cols="12">
                    <fields-selector
                        model-def="helpdesktrouble"
                        :totals="[{ label: 'Totali Ticket Helpdesk', infoTotals: 'info_totals' }]"
                    ></fields-selector>
                </v-col>
            </v-row>

            <v-tabs 
                class="tabs-pill mt-4"
                height="34"
                background-color="background-1"
                slider-color="primary">
                <v-tab key="CampiInterventi" ripple class="secondary-tab">
                    Campi
                </v-tab>
                <v-tab key="AzioniInterventi" ripple class="secondary-tab">
                    Azioni
                </v-tab>

                <v-tab-item class="pb-offset background-1 pt-3" key="CampiInterventi">
                    <v-row class="ma-0 pb-offset">

                        <v-col class="pa-0 pt-2" cols="12">
                            <fields-selector
                                model-def="helpdeskintervention"
                                audit
                                :totals="[{ label: 'Totali Interventi', infoTotals: 'info_totals' }]"
                            ></fields-selector>
                        </v-col>

                    </v-row>
                </v-tab-item>

                <v-tab-item class="pb-offset background-1 pt-3" key="AzioniInterventi">
                    <v-row class="ma-0 pb-offset">

                        <v-col class="pa-0 pt-2" cols="12">
                            <actions-selector model-def="helpdeskintervention" :actions-show="false"></actions-selector>
                        </v-col>

                    </v-row>
                </v-tab-item>
            </v-tabs>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
            <v-row class="ma-0">
                <v-col class="pa-0 pt-2" cols="12">
                    <actions-selector model-def="helpdesktrouble"></actions-selector>
                </v-col>
            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Template">
            <v-row class="ma-0">
                <v-col class="pa-0" cols="12">
                    <crud
                        title='Template Ticket Helpdesk'
                        action-icon='dynamic_feed'
                        model-def='templates-helpdesktrouble'
                        action-position='absolute'
                    ></crud>
                </v-col>
				<v-col class="pa-0 pt-4" cols="12">
                    <crud
                        title='Template Interventi Ticket Helpdesk'
                        action-icon='dynamic_feed'
                        model-def='templates-helpdeskintervention'
                        action-position='absolute'
                    ></crud>
                </v-col>
            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Altro">
            <v-row class="ma-0">
                <helpdesk-options></helpdesk-options>
            </v-row>
        </v-tab-item>

    </v-tabs>
</template>

<script>
import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import HelpdeskOptions from '@/components/modules/helpdesk/settings/HelpdeskOptions'

export default {
    name: 'HelpdeskSettings',
    components: {
        FieldsSelector,
        ActionsSelector,
        HelpdeskOptions
    },
    data() {
        return {
            // Ritorno dal consenso OAuth (code o oauth_error nella query): la
            // casella si gestisce nella scheda "Altro", che altrimenti resta
            // chiusa e il code non verrebbe mai consumato.
            tab: (this.$route.query.code || this.$route.query.oauth_error) ? 3 : 0
        }
    }
}
</script>
